<template>
  <div class="view content">
    <div class="news-container content">
      <div class="news-header">
        {{ $t('news') }}
      </div>
      <div class="card-container">
        <NewsCard v-for="item in news.filter(e => e.isPublished)" :key="item.publicId" class="news-card" vertical :news="item" />
      </div>
    </div>
  </div>
</template>

<script>
import NewsCard from '@/components/NewsCard';

export default {
  components: { NewsCard },

  data() {
    return {
      news: [],
    };
  },

  async mounted() {
    this.news = (await this.$store.dispatch('getNews')).items;
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';

.view {
  padding-top: 90px;
}

.news-header {
  font-weight: 500;
  font-size: 25px;
  line-height: 32px;

  display: flex;
  align-items: left;

  color: colors.$darkblue-color;
}

.news-container {
  display: flex;
  flex-direction: column;

  margin: 96px 0;

  .card-container {
    display: flex;
    flex-wrap: wrap;
  }
}

.news-card {
  width: 384px;
  margin: 16px 8px !important;
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .news-card {
    margin: 8px 0 !important;
  }
}
</style>
